import '.l{display:flex;}.ssr-plugin'
import '.a1{justify-content:center;}.ssr-plugin'
import '.m{flex-direction:column;}.ssr-plugin'
import '.aa{align-items:center;}.ssr-plugin'
import '.n{gap:0.5rem;}.ssr-plugin'
import '.bj{cursor:pointer;}.ssr-plugin'
import '.dp{padding:0.75rem;}.ssr-plugin'
import '.b4{border-radius:1.25rem;}.ssr-plugin'
import '.be{border:var(--border-subtle);}.ssr-plugin'
import '.b5{background-color:var(--palette-white);}.ssr-plugin'
import '.dd{transition:background-color 0.2s ease;}.ssr-plugin'
import '.el{width:2.5rem;}.ssr-plugin'
import '.em{height:2.5rem;}.ssr-plugin'
import '.hf{color:var(--palette-blue-700);}.ssr-plugin'
import '.hg{font-size:0.9rem;}.ssr-plugin'
import '.bs{font-weight:400;}.ssr-plugin'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'inlines'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { MouseEventHandler } from 'react'

export type SocialMediaButtonProps = {
  icon: IconProp
  label: string
  onClick: MouseEventHandler<HTMLButtonElement>
  isMobile?: boolean
}

export const SocialMediaButton = ({
  icon,
  label,
  onClick,
  isMobile,
}: SocialMediaButtonProps) => {
    return (
      <styled.button className="l a1 m aa n bj dp b4 be b5 dd"
        style={{
          '&:hover': {
            backgroundColor: 'var(--palette-blue-50)',
          },
          width: isMobile ? '8rem' : '5.5rem',
          height: isMobile ? '8rem' : '5.5rem',
        }}
        onClick={onClick}
      >
        <div className="el em l aa a1 hf"
          style={{
            fontSize: isMobile ? '3rem' : '2rem',
          }}
        >
          <FontAwesomeIcon icon={icon} />
        </div>
        <span className="hg hf bs"
        >
          {label}
        </span>
      </styled.button>
    )
}